import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../styles/pp-activation.css';
import { useSupportContact } from '../../queries/profile';
import { whatsappDigits } from '../../pages/Devices/Component/Health/model';
import { formatPhone } from './NoPackageState';

/**
 * The calm card for a page whose feature is not in the company's package.
 * Same look as NoPackageState (shares its `.ppn` styles). It is rendered by
 * EntitlementGuard BEFORE the page mounts, so the page makes no gated request.
 * `compact` (inline inside a column/section) only adds a scoped modifier class; the standalone
 * page-level markup/look is unchanged.
 * Support contact comes from GET /support-contact; with no contact, nothing is shown.
 */
export default function FeatureUnavailable({ compact = false }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const support = useSupportContact(true).data;
  const digits = whatsappDigits(support?.whatsapp);

  return (
    <div className={compact ? 'ppn ppn-compact' : 'ppn'} data-testid="feature-unavailable">
      <section className="ppn-card" aria-live="polite">
        <div className="ppn-ic">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="var(--ppn-honey-deep)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
            <rect x="5" y="11" width="14" height="9" rx="2.5" /><path d="M8 11V8a4 4 0 0 1 8 0v3" />
          </svg>
        </div>
        <div>
          <h2>{t('feature_unavailable.title')}</h2>
          <p className="ppn-lead">{t('feature_unavailable.lead')}</p>
        </div>
        <div className="ppn-acts">
          <button className="ppn-btn p" type="button" onClick={() => navigate('/profile', { state: { activeTab: 'billing' } })}>
            {t('feature_unavailable.view_plan')}
          </button>
        </div>
        {digits && (
          <p className="ppn-note">
            <span>{t('feature_unavailable.contact')} <span className="ppn-num" dir="ltr">{formatPhone(support.whatsapp)}</span></span>
          </p>
        )}
      </section>
    </div>
  );
}
